import { Map } from 'immutable'
import { actions } from './actions'

const initialState = Map({
    commentsPosted: false,
    commentsPostingInProgress: false,
})

const contactUs = (state = initialState, action) => {
    const { type } = action

    switch (type) {
        case actions.POST_COMMENTS: {
            return state.merge({
                commentsPosted: true,
                commentsPostingInProgress: true,
            })
        }

        case actions.POST_COMMENTS_SUCCESS: {
            return state.merge({
                commentsPosted: true,
                commentsPostingInProgress: false,
            })
        }

        case actions.POST_COMMENTS_FAILURE: {
            return state.merge({
                commentsPosted: false,
                commentsPostingInProgress: false,
            })
        }

        default:
            return state
    }
}

export default contactUs
